import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  DatePicker,
  Row,
  Col,
  Checkbox,
  Steps,
  notification,
} from "antd";
import { FormularioService } from "../../services/FormularioService";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);



const { Option } = Select;
const { Step } = Steps;

const FormularioFicha = forwardRef(({ json, indicadorId, onSuccess }, ref) => {
  const [form] = Form.useForm();
  const [currentStep, setCurrentStep] = useState(1);
  const [procesoSeleccionado, setProcesoSeleccionado] = useState("");
  const [unidadSeleccionada, setUnidadSeleccionada] = useState("");
  const [unidadMedidaOtra, setUnidadMedidaOtra] = useState("");
  const [otrosDesagregacionTematica, setotrosDesagregacionTematica] = useState(false);
  const [otrosDesagregacionGeografica, setOtrosDesagregacionGeografica] = useState(false);
  const [otrosPeriocidad, setOtrosPeriocidad] = useState(false);
  const [otrosDifusion, setOtrosDifusion] = useState(false);
  const [medioPaginaAplicacionWeb, setMedioPaginaAplicacionWeb] = useState(false);
  const [medioOtro, setMedioOtro] = useState(false);
  const [otroVisualizacion, setOtroVisualizacion] = useState(false);
  const [formData, setFormData] = useState({});
  const [initialValues, setInitialValues] = useState(json || {});



  useImperativeHandle(ref, () => ({
    resetFields: () => form.resetFields(),
    setCurrentStep: (step = 1) => setCurrentStep(step),
  }));


  useEffect(() => {
    if (json) {
      setInitialValues(json);
      form.setFieldsValue(json);
    }
  }, [json]);

  const onFinish = async () => {
    try {
      // Validación para asegurar que tienes todos los datos
      if (
        !formData.procedencia ||
        !formData.codigo ||
        !formData.observaciones
      ) {
        notification.error({
          message: "Error",
          description: "Faltan datos requeridos.",
        });
        return; // Salimos si faltan datos
      }

      // Filtrar campos para eliminar valores no deseados
      let desagregacionGeografica = formData.desagregacionGeografica || [];
      if (Array.isArray(desagregacionGeografica)) {
        desagregacionGeografica = desagregacionGeografica.filter(
          (item) => item !== "otrosDesagregacionGeografica"
        );
      }

      let desagregacionTematica = formData.desagregacionTematica || [];
      if (Array.isArray(desagregacionTematica)) {
        desagregacionTematica = desagregacionTematica.filter(
          (item) => item !== "otrosDesagregacionTematica"
        );
      }

      let periodicidadMedicion = formData.periodicidadMedicion || [];
      if (Array.isArray(periodicidadMedicion)) {
        periodicidadMedicion = periodicidadMedicion.filter(
          (item) => item !== "otrosPeriodicidad"
        );
      }

      let periodicidadDifusion = formData.periodicidadDifusion || [];
      if (Array.isArray(periodicidadDifusion)) {
        periodicidadDifusion = periodicidadDifusion.filter(
          (item) => item !== "otrosDifusion"
        );
      }

      let medioDifusion = formData.medioDifusion || [];
      if (Array.isArray(medioDifusion)) {
        medioDifusion = medioDifusion.filter(
          (item) => item !== "otroMedioDifusion"
        );
      }

      let medioVisualizacion = formData.medioVisualizacion || [];
      if (Array.isArray(medioVisualizacion)) {
        medioVisualizacion = medioVisualizacion.filter(
          (item) => item !== "otroMedioVisualizacion"
        );
      }

      // Estructurar el JSON según los nodos solicitados
      const structuredData = {
        "Información General": {
          procedencia: formData.procedencia || "",
          tipologia: formData.tipologia || "",
          proceso: formData.proceso || "",
          textoAdicionalProceso: formData.textoAdicional || "",
          grupoTrabajo: formData.grupoTrabajo || "",
          telefono: formData.telefono || "",
          email: formData.email || "",
          fecha: formData.fecha || "",
        },
        "Caracterización del Indicador": {
          codigoIndicador: formData.codigo || "",
          nombreIndicador: formData.nombre || "",
          objetivoIndicador: formData.objetivo || "",
          descripcionIndicador: formData.descripcion || "",
          marcoNormativo: formData.marcoNormativo || "",
          formulaIndicador: formData.formula || "",
          unidadMedida: formData.unidadMedida || "",
          unidadMedidaOtra: unidadMedidaOtra,
          variables: formData.variables || "",
          desagregacionTematica: desagregacionTematica, // Filtrado
          desagregacionTematicaOtra: formData.desagregacionTematicaOtra || "",
          desagregacionGeografica: desagregacionGeografica, // Filtrado
          otrosDesagregacionGeografica: formData.otrosDesagregacionGeograficaInput || "",
          periodicidadMedicion: periodicidadMedicion, // Filtrado
          otrosPeriodicidad: formData.otrosPeriodicidad || "",
          fechaDesde: formData.fechaDesde || "",
          fechaHasta: formData.fechaHasta || "",
          periodicidadDifusion: periodicidadDifusion, // Filtrado
          otrosDifusion: formData.otrosDifusionInput || "",
          medioDifusion: medioDifusion, // Filtrado
          urlPaginaAplicacionWeb: formData.urlPaginaAplicacionWeb || "",
          otroMedioDifusion: formData.otroMedioDifusion || "",
          medioVisualizacion: medioVisualizacion, // Filtrado
          otroMedioVisualizacion: formData.otroMedioVisualizacion || "",
        },
        Observaciones: {
          observaciones: formData.observaciones || "",
        },
      };

      // Convertimos el nuevo objeto a JSON
      const fichasJson = JSON.stringify(structuredData);

      // Enviamos el JSON estructurado al servicio
      await FormularioService({
        fichas_json: fichasJson,
        indicador_id: indicadorId,
      });

      notification.success({
        message: "Éxito",
        description: "Los datos han sido enviados correctamente.",
      });

      onSuccess();

      // Restablecer el formulario y el estado
      form.resetFields();
      setFormData({});
      setCurrentStep(1);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Hubo un error al enviar los datos.",
      });
    }
  };

  const handleFieldChange = (changedValues, allValues) => {
    // Actualiza el estado con todos los valores del formulario
    setFormData((prevData) => ({
      ...prevData,
      ...allValues, // Fusiona los valores del formulario en el estado
    }));
  };

  const nextStep = () => {
    form
      .validateFields()
      .then((values) => {
        // Aquí fusionamos el nuevo conjunto de valores con los valores anteriores
        setFormData((prevData) => ({
          ...prevData,
          ...values, // Asegúrate de que los valores actuales se fusionen correctamente
        }));

        if (currentStep < 3) {
          setCurrentStep(currentStep + 1);
        }
      })
      .catch((errorInfo) => {
        console.log("Error en la validación:", errorInfo);
      });
  };

  const previousStep = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleUnidadChange = (value) => {
    setUnidadSeleccionada(value);
  };

  const handleOtraUnidadChange = (e) => {
    setUnidadMedidaOtra(e.target.value);
  };

  const handleOtrosDesagregacionTematica = (checkedValues) => {
    setotrosDesagregacionTematica(
      checkedValues.includes("otrosDesagregacionTematica")
    );
  };

  const handleOtrosDesagregacionGeografica = (checkedValues) => {
    setOtrosDesagregacionGeografica(
      checkedValues.includes("otrosDesagregacionGeografica")
    );
  };

  const handleOtrosPeriodicidad = (checkedValues) => {
    setOtrosPeriocidad(checkedValues.includes("otrosPeriodicidad"));
  };

  const handleOtrosDifusion = (checkedValues) => {
    setOtrosDifusion(checkedValues.includes("otrosDifusion"));
  };

  const handleMedioDifusion = (checkedValues) => {
    setMedioPaginaAplicacionWeb(
      checkedValues.includes("Página o aplicación web")
    );
    setMedioOtro(checkedValues.includes("otro"));
  };

  const handleMedioVisualizacion = (checkedValues) => {
    setOtroVisualizacion(checkedValues.includes("otroVisualizacion"));
  };


  useEffect(() => {
    if (json) {
      // Desestructura los valores del JSON
      const {
        "Información General": informacionGeneral = {},
        "Caracterización del Indicador": caracterizacionIndicador = {},
        Observaciones: observaciones = {}
      } = json;


      // Convierte la fecha a un objeto dayjs
      const fecha = dayjs.utc(informacionGeneral.fecha); // Usa el formato UTC
      const fechaValida = fecha.isValid() ? fecha : null; // Verifica si es válida


      // Mapea los valores al formulario
      const mappedValues = {
        procedencia: informacionGeneral.procedencia,
        tipologia: informacionGeneral.tipologia,
        proceso: informacionGeneral.proceso,
        textoAdicional: informacionGeneral.textoAdicionalProceso,
        grupoTrabajo: informacionGeneral.grupoTrabajo,
        telefono: informacionGeneral.telefono,
        email: informacionGeneral.email,
        fecha: fechaValida,
        codigo: caracterizacionIndicador.codigoIndicador,
        nombre: caracterizacionIndicador.nombreIndicador,
        objetivo: caracterizacionIndicador.objetivoIndicador,
        descripcion: caracterizacionIndicador.descripcionIndicador,
        marcoNormativo: caracterizacionIndicador.marcoNormativo,
        formula: caracterizacionIndicador.formulaIndicador,
        unidadMedida: caracterizacionIndicador.unidadMedida,
        unidadMedidaOtra: caracterizacionIndicador.unidadMedidaOtra,
        variables: caracterizacionIndicador.variables,
        desagregacionTematica: caracterizacionIndicador.desagregacionTematica,
        desagregacionTematicaOtra: caracterizacionIndicador.desagregacionTematicaOtra,
        desagregacionGeografica: caracterizacionIndicador.desagregacionGeografica,
        otrosDesagregacionGeografica: caracterizacionIndicador.otrosDesagregacionGeografica,
        periodicidadMedicion: caracterizacionIndicador.periodicidadMedicion,
        otrosPeriodicidad: caracterizacionIndicador.otrosPeriodicidad,
        periodicidadDifusion: caracterizacionIndicador.periodicidadDifusion,
        otrosDifusion: caracterizacionIndicador.otrosDifusion,
        medioDifusion: caracterizacionIndicador.medioDifusion,
        urlPaginaAplicacionWeb: caracterizacionIndicador.urlPaginaAplicacionWeb,
        otroMedioDifusion: caracterizacionIndicador.otroMedioDifusion,
        medioVisualizacion: caracterizacionIndicador.medioVisualizacion,
        otroMedioVisualizacion: caracterizacionIndicador.otroMedioVisualizacion,

        observaciones: observaciones.observaciones || "", // Asegura que no sea undefined
      };

      // Establece los valores del formulario
      form.setFieldsValue(mappedValues);
    }
  }, [json, form]);


  return (
    <div>
      <Form
        form={form}
        name="ficha-tecnica"
        layout="vertical"
        onFinish={onFinish}
        onValuesChange={handleFieldChange}
        style={{ maxWidth: "1000px", margin: "0 auto" }}
      >
        <h2 style={{ textAlign: "center" }}>
          FICHA TÉCNICA Y SEGUIMIENTO DEL INDICADOR
        </h2>
        <Steps current={currentStep - 1} style={{ marginBottom: "20px" }}>
          <Step title="Módulo A" description="Información general" />
          <Step title="Módulo B" description="Caracterización del indicador" />
          <Step title="Módulo C" description="Observaciones" />
        </Steps>

        {currentStep === 1 && ( // Módulo A
          <>
            <h3>MÓDULO A. INFORMACIÓN GENERAL</h3>
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="procedencia"
                  label="i. Procedencia del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione la procedencia",
                    },
                  ]}
                >
                  <Checkbox.Group>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Línea base de indicadores">
                          Línea base de indicadores
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Plan de Desarrollo Deptal./Plan indicativo">
                          Plan de Desarrollo Deptal./Plan indicativo
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Mapa de procesos">
                          Mapa de procesos
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="ICET">ICET</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Otro">Otro</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="tipologia"
                  label="ii. Tipología del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione la tipología",
                    },
                  ]}
                >
                  <Select>
                    <Option value="eficiencia">Eficiencia</Option>
                    <Option value="eficacia">Eficacia</Option>
                    <Option value="calidad">Calidad</Option>
                    <Option value="economía">Economía</Option>
                    <Option value="efectividad">Efectividad</Option>
                    <Option value="insumo">Insumo</Option>
                    <Option value="proceso">Proceso</Option>
                    <Option value="producto">Producto</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="proceso"
                  label="iii. Proceso al que pertenece el indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione el proceso",
                    },
                  ]}
                >
                  <Select
                    onChange={(value) => {
                      setProcesoSeleccionado(value);
                    }}
                  >
                    <Option value="Estrategico">Estratégico</Option>
                    <Option value="Misional">Misional</Option>
                    <Option value="Apoyo">Apoyo</Option>
                    <Option value="Evaluación">Evaluación</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                {procesoSeleccionado && (
                  <Form.Item
                    name="textoAdicional"
                    label="Texto adicional relacionado con el proceso"
                  >
                    <Input
                      placeholder={`Ingrese información adicional para ${procesoSeleccionado}`}
                    />
                  </Form.Item>
                )}
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="grupoTrabajo"
                  label="iv. Secretaría / Grupo interno de trabajo a cargo del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese la secretaría o grupo",
                    },
                  ]}
                >
                  <Input placeholder="Nombre de la secretaría o grupo" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="telefono"
                  label="v. Teléfono de contacto"
                  rules={[
                    {
                      required: false,
                      message: "Por favor ingrese el teléfono de contacto",
                    },
                  ]}
                >
                  <Input placeholder="Número de teléfono" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="email"
                  label="vi. Correo electrónico"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "Por favor ingrese un correo válido",
                    },
                  ]}
                >
                  <Input placeholder="Correo electrónico" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="fecha"
                  label="vii. Fecha de diligenciamiento de la ficha"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione la fecha",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    placeholder="Seleccione la fecha"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button type="primary" onClick={nextStep}>
                Siguiente
              </Button>
            </Form.Item>
          </>
        )}

        {currentStep === 2 && ( // Módulo B
          <>
            <h3>MÓDULO B. CARACTERIZACIÓN DEL INDICADOR</h3>
            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="codigo"
                  label="1. Código del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese el código del indicador",
                    },
                  ]}
                >
                  <Input placeholder="Ej: DE-IN001" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="nombre"
                  label="2. Nombre del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese el nombre del indicador",
                    },
                  ]}
                >
                  <Input placeholder="Ej: Población registrada en SISBEN IV en el departamento Cauca" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="objetivo"
                  label="3. Objetivo del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese el objetivo del indicador",
                    },
                  ]}
                >
                  <Input placeholder="Ej: Cuantificar la población residente..." />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={8}>
                <Form.Item
                  name="descripcion"
                  label="4. Descripción del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese la descripción del indicador",
                    },
                  ]}
                >
                  <Input placeholder="Ej: Total de personas sisbenizadas..." />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="marcoNormativo"
                  label="5. Marco normativo (si aplica)"
                >
                  <Input placeholder="Ej: Incluye ODS" />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8}>
                <Form.Item
                  name="formula"
                  label="6. Fórmula de cálculo del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese la fórmula de cálculo",
                    },
                  ]}
                >
                  <Input placeholder="Ej: Número de personas incluidas..." />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item
              label="7. Variables para el cálculo del indicador"
              rules={[
                {
                  required: true,
                  message: "Por favor ingrese al menos una variable",
                },
              ]}
            >
              <Form.List name="variables" initialValue={[{}]}>
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }) => (
                      <Row key={key} gutter={16}>
                        <Col xs={24} sm={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "variable"]}
                            label="Variable"
                            rules={[
                              {
                                required: true,
                                message: "Por favor ingrese la variable",
                              },
                            ]}
                          >
                            <Input placeholder="Ej: Número de personas" />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "fuente"]}
                            label="Fuente de datos"
                            rules={[
                              {
                                required: true,
                                message: "Por favor ingrese la fuente de datos",
                              },
                            ]}
                          >
                            <Input placeholder="Ej: DANE, SISBEN" />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "entidad"]}
                            label="Entidad responsable"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Por favor ingrese la entidad responsable",
                              },
                            ]}
                          >
                            <Input placeholder="Ej: Ministerio de Salud" />
                          </Form.Item>
                        </Col>

                        <Col xs={24} sm={6}>
                          <Form.Item
                            {...restField}
                            name={[name, "link"]}
                            label="Link para acceder a la información"
                          >
                            <Input placeholder="Ej: https://ejemplo.com" />
                          </Form.Item>
                        </Col>

                        <Col xs={24}>
                          <Button type="link" onClick={() => remove(name)}>
                            Eliminar
                          </Button>
                        </Col>
                      </Row>
                    ))}
                    <Form.Item>
                      <Button type="primary" onClick={() => add()} block>
                        Agregar variable
                      </Button>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Form.Item>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="unidadMedida"
                  label="8. Unidad de medida del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione la unidad de medida",
                    },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Seleccione una o más opciones"
                    onChange={handleUnidadChange}
                  >
                    <Select.Option value="Tasa">Tasa</Select.Option>
                    <Select.Option value="Porcentaje">Porcentaje</Select.Option>
                    <Select.Option value="Número de personas">
                      Número de personas
                    </Select.Option>
                    <Select.Option value="Hogares">Hogares</Select.Option>
                    <Select.Option value="Pesos">Pesos</Select.Option>
                    <Select.Option value="Hectáreas">Hectáreas</Select.Option>
                    <Select.Option value="Kilómetros">Kilómetros</Select.Option>
                    <Select.Option value="Años">Años</Select.Option>
                    <Select.Option value="otro">Otro</Select.Option>
                  </Select>
                </Form.Item>
                {unidadSeleccionada.includes("otro") && (
                  <Col xs={24} sm={12}>
                    <Form.Item
                      name="unidadMedidaOtra"
                      label="Especifique la otra unidad de medida"
                      rules={[
                        {
                          required: true,
                          message: "Por favor ingrese la unidad de medida",
                        },
                      ]}
                    >
                      <Input
                        placeholder="Especifique la unidad de medida"
                        onChange={handleOtraUnidadChange}
                        value={unidadMedidaOtra}
                      />
                    </Form.Item>
                  </Col>
                )}
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="desagregacionTematica"
                  label="9. Desagregación temática del indicador"
                  rules={[
                    {
                      required: true,
                      message: "Por favor seleccione al menos una opción",
                    },
                  ]}
                >
                  <Checkbox.Group onChange={handleOtrosDesagregacionTematica}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="ninguno">Ninguno</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Sexo">Sexo</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Edad">Edad</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Grupo étnico">Grupo étnico</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Discapacidad">Discapacidad</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Estrato">Estrato</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="otrosDesagregacionTematica">
                          Otro(s), ¿cuál(es)?
                        </Checkbox>
                      </Col>
                      {/* Input para especificar la otra desagregación temática */}
                      {otrosDesagregacionTematica && (
                        <Col span={24} style={{ marginTop: 8 }}>
                          <Form.Item
                            name="desagregacionTematicaOtra"
                            label="Especifique la otra desagregación temática"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Por favor ingrese la otra desagregación temática",
                              },
                            ]}
                          >
                            <Input placeholder="Especifique la otra desagregación temática" />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="desagregacionGeografica"
                  label="10. Desagregación geográfica del indicador"
                >
                  <Checkbox.Group onChange={handleOtrosDesagregacionGeografica}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Departamental">Departamental</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Municipal">Municipal</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Vereda/Corregimiento">
                          Vereda/Corregimiento
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Comuna">Comuna</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Barrio">Barrio</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Cuenca">Cuenca</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Área protegida">
                          Área protegida
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Zona urbana">Zona urbana</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Zona rural">Zona rural</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox
                          value="otrosDesagregacionGeografica"
                          onChange={(e) =>
                            setOtrosDesagregacionGeografica(e.target.checked)
                          } // Cambia el estado cuando se selecciona
                        >
                          Otro(s), ¿cuál(es)?
                        </Checkbox>
                      </Col>
                      {/* Mostrar el input si se seleccionó "Otro(s)" */}
                      {otrosDesagregacionGeografica && (
                        <Col span={24} style={{ marginTop: 8 }}>
                          <Form.Item
                            name="otrosDesagregacionGeograficaInput"
                            label="Especifique la otra desagregación geográfica"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Por favor ingrese la otra desagregación geográfica",
                              },
                            ]}
                          >
                            <Input placeholder="Especifique la otra desagregación geográfica" />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="periodicidadMedicion"
                  label="11. Periodicidad de medición del indicador"
                >
                  <Checkbox.Group onChange={handleOtrosPeriodicidad}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Diaria">Diaria</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Semanal">Semanal</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Mensual">Mensual</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Bimestral">Bimestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Trimestral">Trimestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Semestral">Semestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Anual">Anual</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox
                          value="otrosPeriodicidad"
                          onChange={(e) => setOtrosPeriocidad(e.target.checked)}
                        >
                          Otro
                        </Checkbox>
                      </Col>
                      {otrosPeriocidad && (
                        <Col span={24} style={{ marginTop: 8 }}>
                          <Form.Item
                            name="otrosPeriodicidadInput"
                            label="Especifique la otra periodicidad"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Por favor ingrese la otra periodicidad",
                              },
                            ]}
                          >
                            <Input placeholder="Especifique la otra periodicidad" />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item label="12. Periodos de disponibilidad del indicador">
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        name="fechaDesde"
                        label="Desde"
                        rules={[
                          {
                            required: false,
                            message: "Por favor seleccione la fecha desde",
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="Seleccione la fecha desde"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        name="fechaHasta"
                        label="Hasta"
                        rules={[
                          {
                            required: false,
                            message: "Por favor seleccione la fecha hasta",
                          },
                        ]}
                      >
                        <DatePicker
                          placeholder="Seleccione la fecha hasta"
                          style={{ width: "100%" }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="periodicidadDifusion"
                  label="13. Periodicidad con la que se difunde el indicador"
                >
                  <Checkbox.Group onChange={handleOtrosDifusion}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Diaria">Diaria</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Semanal">Semanal</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Mensual">Mensual</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Bimestral">Bimestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Trimestral">Trimestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Semestral">Semestral</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Anual">Anual</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="No se difunde">No se difunde</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox
                          value="otrosDifusion"
                          onChange={(e) => setOtrosDifusion(e.target.checked)}
                        >
                          Otro
                        </Checkbox>
                      </Col>
                      {otrosDifusion && (
                        <Col span={24} style={{ marginTop: 8 }}>
                          <Form.Item
                            name="otrosDifusionInput"
                            label="Especifique la otra periodicidad"
                            rules={[
                              {
                                required: true,
                                message:
                                  "Por favor ingrese la otra periodicidad",
                              },
                            ]}
                          >
                            <Input placeholder="Especifique la otra periodicidad" />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="medioDifusion"
                  label="14. Medio en el cual se difunde el resultado del indicador"
                >
                  <Checkbox.Group onChange={handleMedioDifusion}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Página o aplicación web">
                          Página o aplicación web
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Medio físico">Medio físico</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Correo electrónico">
                          Correo electrónico
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Geovisor">Geovisor</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="otroDifusionMedio">Otro</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="No se difunde">No se difunde</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                {medioPaginaAplicacionWeb && (
                  <Form.Item
                    name="urlPaginaAplicacionWeb"
                    label="Especifique la URL de la página o aplicación web"
                    rules={[
                      {
                        required: true,
                        message:
                          "Por favor ingrese la URL de la página o aplicación web",
                      },
                    ]}
                  >
                    <Input placeholder="Ej: https://www.ejemplo.com" />
                  </Form.Item>
                )}

                {medioOtro && (
                  <Form.Item
                    name="otroMedioDifusion"
                    label="Especifique el otro medio"
                    rules={[
                      {
                        required: true,
                        message: "Por favor ingrese el otro medio de difusión",
                      },
                    ]}
                  >
                    <Input placeholder="Especifique el otro medio" />
                  </Form.Item>
                )}
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="medioVisualizacion"
                  label="15. Medio de visualización en el cual se encuentra disponible los resultados del indicador (en la página o aplicación web)"
                >
                  <Checkbox.Group onChange={handleMedioVisualizacion}>
                    <Row>
                      <Col span={24}>
                        <Checkbox value="Formato Excel">Formato Excel</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Formato PDF">Formato PDF</Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Imágenes o tablas estáticas">
                          Imágenes o tablas estáticas
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Imágenes o tablas interactivas">
                          Imágenes o tablas interactivas
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="Mapas interactivos (geovisor)">
                          Mapas interactivos (geovisor)
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="otroVisualizacion">
                          Otro Medio
                        </Checkbox>
                      </Col>
                      <Col span={24}>
                        <Checkbox value="No se difunde">No se difunde</Checkbox>
                      </Col>
                    </Row>
                  </Checkbox.Group>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                {otroVisualizacion && (
                  <Form.Item
                    name="otroMedioVisualizacion"
                    label="Especifique el otro medio de visualización"
                    rules={[
                      {
                        required: true,
                        message:
                          "Por favor ingrese el otro medio de visualización",
                      },
                    ]}
                  >
                    <Input placeholder="Especifique el otro medio" />
                  </Form.Item>
                )}
              </Col>
            </Row>

            <Form.Item>
              <Button onClick={previousStep} style={{ marginRight: "8px" }}>
                Anterior
              </Button>
              <Button type="primary" onClick={nextStep}>
                Siguiente
              </Button>
            </Form.Item>
          </>
        )}

        {currentStep === 3 && ( // Módulo C
          <>
            <h3>MÓDULO C. OBSERVACIONES</h3>
            <h5>
              En este espacio relacione las aclaraciones que considere
              pertinentes sobre información del indicador.
            </h5>
            <Row gutter={16}>
              <Col xs={24} sm={24}>
                <Form.Item
                  name="observaciones"
                  label="Observaciones"
                  rules={[
                    {
                      required: true,
                      message: "Por favor ingrese las observaciones",
                    },
                  ]}
                >
                  <Input.TextArea placeholder="Ingresa tus observaciones" />
                </Form.Item>
              </Col>
            </Row>

            <Form.Item>
              <Button onClick={previousStep} style={{ marginRight: "8px" }}>
                Anterior
              </Button>
              <Button type="primary" htmlType="submit">
                Enviar
              </Button>
            </Form.Item>
          </>
        )}
      </Form>

    </div>
  );


});

export default FormularioFicha;
